<div
  #modalContents
  [ngClass]="[lmodalContentsClassWithWidth, 'js-wModal-contents']"
  aria-modal="true"
  role="dialog"
  aria-labelledby="modalTitle2"
>
  <div #modalHead [ngClass]="[lmodalHeaderClass, 'js-wModal-head']">
    <div class="p-modal-head04">
      <h1
        id="modalTitle2"
        class="p-modal-head04__title"
        [innerHTML]="'label.supportInformation.title2' | staticMsg"
      ></h1>
      <!-- [14.1] 閉じる -->
      <button
        id="special-assistance-request-modal-close-button1"
        class="p-modal-head04__close js-wModal-close"
        (click)="onClickClose()"
      >
        <span class="u-visually-hidden" [innerHTML]="'label.close' | staticMsg"></span>
      </button>
    </div>
  </div>
  <asw-alert-message *ngIf="isError" [item]="alertMessageItem"></asw-alert-message>
  <div #modalBody [ngClass]="[lmodalBodyClass, 'js-wModal-body']">
    <ng-container [ngSwitch]="type">
      <!-- [14.2] サポート選択 -->
      <asw-special-assistance-request-modal-special-assistance
        #specialAssistanceCom
        *ngSwitchCase="'specialAssistance'"
        [(data)]="specialAssistance"
      ></asw-special-assistance-request-modal-special-assistance>
      <!-- [14.8] 歩行の程度 -->
      <asw-special-assistance-request-modal-walking-ability
        #walkingAbilityCom
        *ngSwitchCase="'walkingAbility'"
        [(data)]="walkingAbility"
        [master]="walkingAbilityMaster"
      ></asw-special-assistance-request-modal-walking-ability>
      <!-- [14.10] 車いす持ち込み有無 -->
      <asw-special-assistance-request-modal-wheelchairs
        #wheelchairsCom
        *ngSwitchCase="'wheelchairs'"
        [(data)]="wheelchairs"
      ></asw-special-assistance-request-modal-wheelchairs>
      <!-- [14.12] 折りたたみ可否・サイズ -->
      <asw-special-assistance-request-modal-folding-type
        #foldingTypeCom
        *ngSwitchCase="'foldingType'"
        [(data)]="foldingType"
      ></asw-special-assistance-request-modal-folding-type>
      <!-- [14.19] 車いす種類・バッテリータイプ -->
      <asw-special-assistance-request-modal-wheelchair-type
        #wheelchairTypeCom
        *ngSwitchCase="'wheelchairType'"
        [master]="wheelchairTypeMaster"
        [(data)]="wheelchairType"
      ></asw-special-assistance-request-modal-wheelchair-type>
      <!-- [14.22] 妊婦中情報 -->
      <asw-special-assistance-request-modal-pregnant
        #pregnantCom
        *ngSwitchCase="'pregnant'"
        [master]="pregnantMaster"
        [(data)]="pregnant"
      ></asw-special-assistance-request-modal-pregnant>
    </ng-container>
  </div>
  <!-- [14.30] サポート情報モーダルボタン表示エリア -->
  <div #modalFooter [ngClass]="[lmodalFooterClass, 'js-wModal-footer', 'is-shadow']">
    <div
      class="p-modal-foot03"
      [ngClass]="{ 'p-modal-foot01': type === 'specialAssistance', 'p-modal-foot03': type !== 'specialAssistance' }"
    >
      <!-- [14.32] 戻る -->
      <asw-button
        *ngIf="type !== 'specialAssistance'"
        type="secondary"
        size="s-min-w100"
        [label]="'label.goBack' | staticMsg"
        (click$)="onClickBack()"
      ></asw-button>
      <!-- [14.31] 次へ -->
      <asw-button
        *ngIf="isNext()"
        type="primary"
        size="s-min-w100"
        [label]="'label.next' | staticMsg"
        (click$)="onClickNext()"
      ></asw-button>
      <!-- [14.33] 適用 -->
      <asw-button
        *ngIf="isSubmit()"
        type="primary"
        size="s-min-w100"
        [label]="'label.submit' | staticMsg"
        (click$)="onClickSubmit()"
      ></asw-button>
    </div>
  </div>
</div>
